//Import React Hooks
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';

// import created components  :
import Background from '../../../components/background/Background.jsx'
import WallyBanner from '../../../components/wallybanner/WallyBanner.jsx' //<WallyBanner />
import ProgressBar from '../../../components/progressbar/ProgressBar.jsx'
import PeriodeSelect from '../../../components/location/periodeselect/PeriodeSelect.jsx'
import RecapPanier from '../../../components/location/recappanier/RecapPanier.jsx'
import ShoppingGallery from '../../../components/location/shoppingGallery/ShoppingGallery.jsx';
import ClientInfos from '../../../pages/clientinfos/ClientInfos.jsx'
import PanierList from '../../../components/location/panierList/PanierList.jsx';
import LocationValidate from '../../../components/location/locationvalidate/LocationValidate.jsx';

//selectors for redux :
import { useSelector, useDispatch } from "react-redux";

// tools and component for date picker
import dayjs from 'dayjs';
import 'dayjs/locale/fr';

//MUI :
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Alert from '@mui/material/Alert';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';
import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import EditIcon from '@mui/icons-material/Edit';
import PlaceIcon from '@mui/icons-material/Place';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';

// API fetch
import axios from "axios";
import { baseURL } from '../../../config/api-config.js';

//data
import { openingHours } from '../../../data/location-params'

//Translate utils :
import { translator } from "../../../utils/translator.js"
import parse from 'html-react-parser';
//import { useSelector, useDispatch } from "react-redux";
import { getLang, getStepLocation, getPanier, getClient, getLocation } from "../../../store/selectors.js"; //global state : shopping state
import { locationSlice } from '../../../store/locationSlice.js';
import { stepLocationSlice } from '../../../store/stepLocationSlice.js';

import { clientSlice } from "../../../store/clientSlice.js";
import { panierSlice } from '../../../store/panierSlice.js';
//const lang = useSelector(getLang) //global state : language
// translator(original, lang, ref)

import convertHoraire from '../../../utils/convert_horaire'
import { calculDuree, getDureeInfos } from '../../../utils/calcul-duree'

function LocationSteps() { // full page as component imported in router

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const lang = useSelector(getLang) //global state : shopping step
    const panier = useSelector(getPanier) //global state : shopping step
    const client = useSelector(getClient) //global state : shopping step
    const location = useSelector(getLocation) //global state : shopping step

    const locationStep = useSelector(getStepLocation) //global state : shopping step
    const [dbArticles, setDbArticles] = useState([])
    const [dbTailles, setDbTailles] = useState([])
    const [formValid, setFormValid] = useState(false);




    useEffect(() => {

        dispatch(locationSlice.actions.setLocation({
            id_location: 0,
            ref_location: "ref",
            spot_id: 0,
            client_id: 0,
            d1: dayjs().format("YYYY-MM-DD"),
            d2: dayjs().format("YYYY-MM-DD"),
            h1: openingHours[0],
            h2: openingHours[1],
            match: false,
            paye: 0,
            coupon: 0,
            mode_reglement: 0,
            total: 0,
            solde: 0,
            retour: false,
            date_crea: dayjs().format("YYYY-MM-DD"),
            commentaire: "",
            garantie: "",
            nb_combos: 0,
            discount_combos: 0
        }))




        /* dispatch(panierSlice.actions.setPanier([
            {
                location_id: 0,
                article_id: 1,
                qte: 2,
                taille_id: 1
            },
            {
                location_id: 0,
                article_id: 2,
                qte: 1,
                taille_id: 5
            },
        ])) */

        async function initArticles() {
            const resp = await axios.get(`${baseURL}/article`);
            let sortedArticles = resp.data.toSorted((a1, a2) => a1.type_id > a2.type_id ? 1 : -1);

            setDbArticles(sortedArticles.toSorted((a1, a2) => a1.categorie_id > a2.categorie_id ? 1 : -1));

            console.log(resp.data)
        }
        initArticles()

        async function initTailles() {
            const resp = await axios.get(`${baseURL}/taille`);
            setDbTailles(resp.data);
        }
        initTailles()

        let staticClient = { id_client: -1, prenom: "", nom: "", email: "", tel: "", tel2: "", adresse_vacances: "", is_eleve: false, eleve_id: 0 };
        dispatch(clientSlice.actions.setClient(staticClient));

    }, [])

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [locationStep])

    function checkNext() {
        switch (locationStep) {
            case 1:
                return panier.length > 0;

            case 2:
                return formValid;
            default:
                return true;
        }
    }

    function setCommentaire(info) {
        dispatch(locationSlice.actions.modifLocation([
            { champ: "commentaire", value: info }
        ]))

    }


    return (
        <div className="bg-relative">
            <Background ind={3} />
            <main> {/* main is positionned absolute */}
                <div className="main-relative">
                    <WallyBanner mode="location" />
                    <div className="main-progress-bar border-green">
                        <ProgressBar currentStep={locationStep} total={4} />
                    </div>

                    {locationStep < 3 ?
                        <div className="location-top-sticky">
                            <div className="main-container">
                                <PeriodeSelect />

                            </div>

                            <div className="main-container">
                                <RecapPanier dbArticles={dbArticles} dbTailles={dbTailles} />

                            </div>
                        </div>
                        : null}



                    {locationStep === 1 ? <div className="main-container">
                        <ShoppingGallery dbArticles={dbArticles} dbTailles={dbTailles} />

                    </div>
                        : null}

                    {locationStep === 2 ?
                        <ClientInfos setFormValid={setFormValid} />
                        : null}

                    {locationStep === 3 ?
                        <section>
                            <div className="main-container">

                                <div className="location-step3-infos-periode">
                                    <h3>{translator("Durée de location", lang, "locationStep3Duree")}</h3>
                                    <div className="location-step3-bt-edit"
                                        onClick={_ => dispatch(stepLocationSlice.actions.setStep(1))}
                                    ><EditIcon />
                                    </div>
                                    <div className="location-step3-infos-periode-content">
                                        <div>
                                            <p>{translator("Du", lang, "DatePickFrom")} {dayjs(location.d1).format("dddd DD/MM")} {translator("à", lang, "DatePickAt")} {convertHoraire(location.h1, "horaire")}</p>
                                        </div>
                                        <div>
                                            <p>{translator("Au", lang, "DatePickTo")} {dayjs(location.d2).format("dddd DD/MM")} {translator("à", lang, "DatePickAt")} {convertHoraire(location.h2, "horaire")}</p>
                                        </div>
                                        <div>
                                            <h4>{translator("du : ", lang, "DureeEquals")} {getDureeInfos(calculDuree(location))}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="main-container">

                                <div className="location-step3-infos-periode">
                                    <h3>{translator("Point de location", lang, "locationStep3Spot")}</h3>
                                    <div className="location-step3-infos-periode-content">
                                        <div>
                                            <p>{translator("Point de retrait du matériel : Wally Glisse, Parking du Lion (plage super sud)", lang, "locationStep3Spot2")}</p>
                                        </div>
                                        <div className="location-step3-infos-spot">
                                            <p><PlaceIcon /><a href="https://www.google.com/maps/dir//Rte+du+Lion,+33680+Lacanau/@44.9805571,-1.2823606,31513m/data=!3m1!1e3!4m8!4m7!1m0!1m5!1m1!1s0xd54ab32ec61f2ff:0xf57c2c1e094c5f!2m2!1d-1.19996!2d44.9805867?entry=ttu&g_ep=EgoyMDI1MDYwNC4wIKXMDSoASAFQAw%3D%3D" target="_blank">{translator("Itinéraire", lang, "locationStep3Spot3")}</a></p>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="main-container">

                                <div className="location-step3-panier-title">
                                    <h3>{translator("Votre panier", lang, "locationStep3Panier")}</h3>
                                    <div className="location-step3-bt-edit"
                                        onClick={_ => dispatch(stepLocationSlice.actions.setStep(1))}
                                    ><EditIcon />
                                    </div>
                                </div>
                                <PanierList dbArticles={dbArticles} dbTailles={dbTailles} />

                            </div>
                            <div className="main-container">

                                <div className="location-step3-infos-client">
                                    <h3>{translator("Vos coordonnées", lang, "confirmResaInfos")}</h3>
                                    <div className="location-step3-bt-edit"
                                        onClick={_ => dispatch(stepLocationSlice.actions.setStep(2))}><EditIcon />
                                    </div>
                                    <div className="location-step3-infos-client-content">
                                        <div>
                                            <h4>{client.prenom + " " + client.nom}</h4>
                                            <p>{translator("Téléphone : ", lang, "formInfosPhone") + client.tel}</p>
                                            <p>{"Email : " + client.email}</p>

                                        </div>
                                        <div>
                                            <p>{translator("Téléphone 2 : ", lang, "formInfosPhone2") + client.tel2}</p>
                                            {client.adresse_vacances != "" ?
                                                <p>{translator("Adresse de vacances : ", lang, "formInfosAddress") + client.adresse_vacances}</p>
                                                :
                                                null
                                            }
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="main-container">

                                <div className="location-step3-infos-client">
                                    <h3>{translator("Commentaire", lang, "confirmResaComment")}</h3>

                                    <div className="location-step3-commentaire">
                                        <p>{translator("Besoin de préciser votre demande? laisser nous un petit commentaire :", lang, "locationStep3Comment")}</p>
                                        <TextField
                                            fullWidth
                                            label={translator("Commentaire", lang, "confirmResaComment")}
                                            value={location.commentaire}
                                            onChange={(event) => {
                                                setCommentaire(event.target.value);
                                            }}
                                        />

                                    </div>
                                </div>

                            </div>

                        </section>
                        : null}

                    {locationStep === 4 ?
                        <div className="main-container">

                            <div className="location-step3-infos-client">
                                <h3>{translator("Merci pour votre demande", lang, "locationStep4Merci")}</h3>

                                <div className="location-step4">
                                    <div className="location-step4-content">

                                        <p>{parse(translator("Votre demande de location de matériel nous est bien parvenue.", lang, "locationStep4P1"))}</p>
                                        <p>{parse(translator("Nous allons étudier ça <strong>très rapidement</strong> pour voir si nous pouvons donner suite, en fonction de nos stocks disponibles, des horaires et des conditions météo.", lang, "locationStep4P2"))}</p>
                                        <p>{parse(translator("Vous allez recevoir <strong>par email</strong> notre réponse avec un lien vers notre page de paiement en ligne, si votre demande peut être acceptée. Très cordialement!🤙", lang, "locationStep4P3"))}</p>

                                    </div>

                                    <Button
                                        className="bottom-nav-prev"
                                        onClick={_ => navigate('/location')}
                                        variant="contained">
                                        <KeyboardReturnIcon />{translator("Revenir à l'accueil", lang, "BtPrevious")}
                                    </Button>
                                </div>
                            </div>

                        </div>
                        : null}

                    {locationStep < 4 ?
                        <div className="bottom-nav">
                            {locationStep > 1 &&
                                <Button
                                    className="bottom-nav-prev"
                                    onClick={_ => dispatch(stepLocationSlice.actions.prevStep())}
                                    variant="contained">
                                    <SkipPreviousIcon />{translator("Précédent", lang, "BtPrevious")}
                                </Button>
                            }

                            {
                                locationStep > 2 ?
                                    /* <Button
                                        className="bottom-nav-next"
                                        onClick={_ => dispatch(stepLocationSlice.actions.nextStep())}
                                        variant="contained">
                                        {translator("Envoyer votre demande de location", lang, "BtSendLoc")}
                                    </Button> */
                                    <LocationValidate dbArticles={dbArticles} dbTailles={dbTailles} />

                                    :
                                    <Button
                                        className="bottom-nav-next"
                                        onClick={_ => dispatch(stepLocationSlice.actions.nextStep())}
                                        variant="contained"
                                        disabled={!checkNext()}>
                                        {translator("Suivant", lang, "BtNext")} <SkipNextIcon />

                                    </Button>

                            }

                        </div>
                        : null}
                </div>


            </main>

        </div >
    );
}

export default LocationSteps;